import Select from "react-select";

const MerchantList = ({ selectedMerchant, merchantList, onMerchantSelect }) => {
  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#f0f0f0"
        : state.isFocused
          ? "#f0f0f0"
          : "white",

      color: "black",
      cursor: "pointer",
    }),
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      "&:hover": {
        border: "none",
      },
    }),
    // Keep the portaled menu above the card chain connector (z-index: 2).
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const handleChange = (selectedMerchant) => {
    onMerchantSelect(selectedMerchant);
  };

  return (
    <div className="merchant-list">
      <label htmlFor="merchant-select">Select Merchant</label>
      <Select
        inputId="merchant-select"
        className="select-list"
        isSearchable={true}
        menuPlacement="auto"
        placeholder={"Select Merchant"}
        defaultValue={selectedMerchant}
        menuPortalTarget={document.body}
        options={merchantList}
        noOptionsMessage={() => "No merchants found"}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        styles={customStyles}
      />
    </div>
  );
};

export default MerchantList;
